import {RecordAuditMetadataFormValue} from '../components/recordAuditMetadataFormSchema';

// Drops blank rows (no employee or no profession picked) before sending.
export const toRecordAuditParticipants = (
  participants: RecordAuditMetadataFormValue['participants']
) =>
  participants.filter(
    (participant) => participant.employeeId !== '' && participant.professionId !== ''
  );
